module.exports = __webpack_public_path__ + "img/bg1.9ad02ae3.png";